import { ProductCategoryType } from "@/lib/main";
import ProductCard from "./ProductCard";

type Props = ProductCategoryType;

export default function ProductCards({
  category,
  subCategory,
  favoriteList,
  productList,
}: Props) {
  return (
    <>
      {productList
        .filter((product) => {
          const isCategoryMatch = product.category === category;
          const isSubCategoryMatch = subCategory
            ? product.subCategory === subCategory
            : true;
          const isFavoriteListMatch = favoriteList
            ? product.favoriteList?.includes(favoriteList)
            : true;
          return isCategoryMatch && isSubCategoryMatch && isFavoriteListMatch;
        })
        .map((product) => (
          <ProductCard
            key={product.id}
            id={product.id}
            name={product.name}
            brand={product.brand}
            image={product.image}
            size={product.size}
            description={product.description}
            price={product.price}
            originalPrice={product.originalPrice}
            rating={product.rating}
          />
        ))}
    </>
  );
}
